'use strict';
module.exports = require('./Checkbox.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/checkbox/index.js
// module id = 21
// module chunks = 1